/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

const DrawerFooter = React.forwardRef((props, ref) => {

  const {
    children,
    ...other
  } = props;

  const classes = 'sui-bg-primary sui-p-4 sui-relative sui-bottom-0 sui-sticky';

  return (
    <div
      className={classes}
      ref={ref}
      {...other}
    >
      {children}
    </div>
  );
});

DrawerFooter.displayName = 'DrawerFooter';

DrawerFooter.propTypes = {
  children: PropTypes.node,
};

DrawerFooter.defaultProps = {
};

export { DrawerFooter };